export default "__VITE_ASSET__6Eut88NU__"